(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Accessibility helper function for screen reader announcements

    // Product category filtering
// Product category filtering

const categoryFilters = document.querySelectorAll(
  '.category-filter[data-filter]'
);

const genderSubfilters = document.querySelectorAll(
  '.gender-subfilter'
);

const genderSubnav =
  document.getElementById('gender-subnav');

const productItems =
  document.querySelectorAll('.product-filter-item');

const productGrid =
  productItems.length > 0
    ? productItems[0].parentElement
    : null;

const originalProductOrder =
  new Map(
    [...productItems].map((product, index) => [
      product,
      index
    ])
  );


let activeGender = null;
let activeSubfilter = 'all';


function getProductTags(product) {
  return (product.dataset.productTags || '')
    .split('|')
    .map((tag) => tag.trim().toLowerCase())
    .filter(Boolean);
}

function restoreOriginalProductOrder() {
  if (!productGrid) return;

  const products = [...productItems];

  products.sort((a, b) => {
    return (
      originalProductOrder.get(a) -
      originalProductOrder.get(b)
    );
  });

  products.forEach((product) => {
    productGrid.appendChild(product);
  });
}


function prioritizeWomensProducts() {
  if (!productGrid) return;

  const products = [...productItems];

  function getWomensPriority(product) {
    const tags = getProductTags(product);

    const hasWomens = tags.includes('womens');
    const hasMens = tags.includes('mens');

    // Womens-only first
    if (hasWomens && !hasMens) {
      return 0;
    }

    // Products tagged with both come second
    if (hasWomens && hasMens) {
      return 1;
    }

    // Everything else comes last
    return 2;
  }

  products.sort((a, b) => {
    const priorityDifference =
      getWomensPriority(a) -
      getWomensPriority(b);

    if (priorityDifference !== 0) {
      return priorityDifference;
    }

    // Preserve existing collection order inside each group
    return (
      originalProductOrder.get(a) -
      originalProductOrder.get(b)
    );
  });

  products.forEach((product) => {
    productGrid.appendChild(product);
  });
}


function applyProductFilters() {
  productItems.forEach((product) => {
    const tags = getProductTags(product);

    const matchesGender =
      !activeGender ||
      tags.includes(activeGender);

    let matchesSubfilter = true;


    if (activeSubfilter === 'accessories') {
      matchesSubfilter =
        tags.includes('accessories');
    }


    if (activeSubfilter === 'ready-to-wear') {
      matchesSubfilter =
        tags.includes('ready to wear') ||
        tags.includes('ready-to-wear') ||
        tags.includes('ready_to_wear');
    }


    product.style.display =
      matchesGender && matchesSubfilter
        ? ''
        : 'none';
  });
}


function setPrimaryActive(activeButton) {
  categoryFilters.forEach((button) => {
    button.classList.remove('active');
  });

  activeButton.classList.add('active');
}


function resetGenderSubmenu() {
  activeSubfilter = 'all';

  genderSubfilters.forEach((button) => {
    button.classList.toggle(
      'active',
      button.dataset.subfilter === 'all'
    );
  });
}


categoryFilters.forEach((button) => {
  button.addEventListener('click', function () {
    const filter = button.dataset.filter;


    if (button.classList.contains('active')) {
      button.classList.remove('active');

      activeGender = null;
      if (productGrid) {
        delete productGrid.dataset.activeGender;
      }

      resetGenderSubmenu();

      genderSubnav.hidden = true;

      categoryNav.classList.remove('has-gender-selection');
      restoreOriginalProductOrder();
      applyProductFilters();

      return;
    }

    setPrimaryActive(button);


    // MENS / WOMENS

    if (
      filter === 'mens' ||
      filter === 'womens'
    ) {
      activeGender = filter;
      if (productGrid) {
        productGrid.dataset.activeGender = filter;
      }

      resetGenderSubmenu();

      genderSubnav.hidden = false;

      categoryNav.classList.add('has-gender-selection');

      if (filter === 'womens') {
        prioritizeWomensProducts();
      } else {
        restoreOriginalProductOrder();
      }

      applyProductFilters();

      return;
    }


    // ACCESSORIES

    if (filter === 'accessories') {
      activeGender = null;
      activeSubfilter = 'accessories';

      genderSubnav.hidden = true;

      categoryNav.classList.remove('has-gender-selection');

      applyProductFilters();
    }
  });
});


genderSubfilters.forEach((button) => {
  button.addEventListener('click', function () {
    activeSubfilter =
      button.dataset.subfilter;

    genderSubfilters.forEach((subfilter) => {
      subfilter.classList.remove('active');
    });

    button.classList.add('active');

    applyProductFilters();
  });
});

// Hide only the logo and move the category navigation to the top
const siteHeader = document.getElementById('site-header');
const categoryNav = document.getElementById('category-nav');

function updateHomepageHeader() {
  if (!siteHeader || !categoryNav) return;

  const shouldCollapse = window.scrollY > 20;

  siteHeader.classList.toggle(
    'site-header-collapsed',
    shouldCollapse
  );

  categoryNav.classList.toggle(
    'category-nav-stuck',
    shouldCollapse
  );
}

window.addEventListener('scroll', updateHomepageHeader, {
  passive: true,
});

updateHomepageHeader();

    function announceToScreenReader(message) {
      const announcement = document.createElement('div');
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('aria-atomic', 'true');
      announcement.className = 'sr-only';
      announcement.textContent = message;
      document.body.appendChild(announcement);

      setTimeout(() => {
        document.body.removeChild(announcement);
      }, 1000);
    }

    // Focus trap utility
    function trapFocus(container) {
      const focusableElements = container.querySelectorAll(
        'a, button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
      );

      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      container.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') {
          if (e.shiftKey) {
            if (document.activeElement === firstElement) {
              lastElement.focus();
              e.preventDefault();
            }
          } else {
            if (document.activeElement === lastElement) {
              firstElement.focus();
              e.preventDefault();
            }
          }
        }
      });
    }

    // Mobile Menu
    const menuToggles = document.querySelectorAll('.mobile-menu-toggle');
    const menuClose = document.querySelector('.mobile-menu-close');
    const mobileMenu = document.querySelector('.mobile-menu');
    const menuOverlay = document.querySelector('.mobile-menu-overlay');

    function openMenu() {
      // Check if desktop or mobile
      const isDesktop = window.innerWidth >= 768;

      if (isDesktop) {
        // Desktop: slide in from left (remove the md:-translate-x-full and add translate-x-0)
        mobileMenu.classList.remove('md:-translate-x-full');
        mobileMenu.classList.add('md:translate-x-0');
      } else {
        // Mobile: slide in from right
        mobileMenu.classList.remove('translate-x-full');
        mobileMenu.classList.add('translate-x-0');
      }

      menuOverlay.style.display = 'block';
      document.body.style.overflow = 'hidden';

      // Accessibility enhancements
      menuToggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'true');
      });

      // Focus management
      mobileMenu.focus();

      // Trap focus within menu
      trapFocus(mobileMenu);
      const focusableElements = mobileMenu.querySelectorAll('a, button');
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }

      // Announce menu opening
      announceToScreenReader('Navigation menu opened');
    }

    function closeMenu() {
      // Check if desktop or mobile
      const isDesktop = window.innerWidth >= 768;

      if (isDesktop) {
        // Desktop: slide out to left
        mobileMenu.classList.remove('md:translate-x-0');
        mobileMenu.classList.add('md:-translate-x-full');
      } else {
        // Mobile: slide out to right
        mobileMenu.classList.remove('translate-x-0');
        mobileMenu.classList.add('translate-x-full');
      }

      menuOverlay.style.display = 'none';
      document.body.style.overflow = '';

      // Accessibility enhancements
      menuToggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus(); // Return focus to menu button
      });

      // Announce menu closing
      announceToScreenReader('Navigation menu closed');
    }

    menuToggles.forEach((toggle) => {
      toggle.addEventListener('click', openMenu);
    });

    if (menuClose) {
      menuClose.addEventListener('click', closeMenu);
    }

    if (menuOverlay) {
      menuOverlay.addEventListener('click', closeMenu);
    }

const searchToggle = document.getElementById('predictive-search-toggle');
const searchPanel = document.getElementById('predictive-search-panel');
const searchInput = document.getElementById('predictive-search-input');
const searchResults = document.getElementById('predictive-search-results');
const searchStatus = document.getElementById('predictive-search-status');
const searchClose = document.getElementById('predictive-search-close');

let searchDebounceTimer;
let searchAbortController;

if (searchClose) {
  searchClose.addEventListener('click', function () {
    closeSearch();
    searchToggle.focus();
  });
}

function openSearch() {
  searchPanel.classList.remove('hidden');
  searchToggle.setAttribute('aria-expanded', 'true');

  // Raise the header above the category navigation on all screen sizes
  siteHeader.classList.add('search-is-open');

  if (window.innerWidth < 768) {
    document.body.style.overflow = 'hidden';

    if (categoryNav) {
      categoryNav.classList.add('search-hidden');
    }
  }

  requestAnimationFrame(() => {
    searchInput.focus();
  });
}

function closeSearch() {
  searchPanel.classList.add('hidden');
  searchResults.classList.add('hidden');
  searchResults.innerHTML = '';
  searchToggle.setAttribute('aria-expanded', 'false');

  document.body.style.overflow = '';

  siteHeader.classList.remove('search-is-open');

  if (categoryNav) {
    categoryNav.classList.remove('search-hidden');
  }

  if (searchAbortController) {
    searchAbortController.abort();
  }
}

function escapeHTML(value) {
  const element = document.createElement('div');
  element.textContent = value ?? '';
  return element.innerHTML;
}

function renderSearchResults(products, query) {
  if (!products.length) {
    searchResults.innerHTML = `
      <div class="px-3 py-3 text-xs">
        NO PRODUCTS FOUND
      </div>
    `;

    searchResults.classList.remove('hidden');
    searchStatus.textContent = `No products found for ${query}`;
    return;
  }

  searchResults.innerHTML = products
    .map((product) => {
      const productImage = product.image
        ? `
          <img
            src="${product.image}"
            alt=""
            class="h-16 w-12 shrink-0 object-contain"
            width="48"
            height="64"
          >
        `
        : `
          <div class="h-16 w-12 shrink-0"></div>
        `;

      const productPrice = product.price
        ? `
          <div class="mt-1 text-xs">
            ${escapeHTML(product.price)}
          </div>
        `
        : '';

      return `
        <a
          href="${product.url}"
          class="flex items-center gap-3 px-3 py-3 no-underline hover:bg-gray-100"
          role="option"
        >
          ${productImage}

          <div class="min-w-0">
            <div class="text-sm">
              ${escapeHTML(product.title).toUpperCase()}
            </div>

            ${productPrice}
          </div>
        </a>
      `;
    })
    .join('');

  searchResults.classList.remove('hidden');

  searchStatus.textContent =
    `${products.length} product${products.length === 1 ? '' : 's'} found for ${query}`;
}

async function performPredictiveSearch(query) {
  if (searchAbortController) {
    searchAbortController.abort();
  }

  searchAbortController = new AbortController();

  try {
    const url =
      `${window.Shopify.routes.root}search/suggest.json` +
      `?q=${encodeURIComponent(query)}` +
      `&resources[type]=product` +
      `&resources[limit]=6` +
      `&resources[options][fields]=title,product_type,variants.title,vendor,tag`;

    const response = await fetch(url, {
      signal: searchAbortController.signal,
    });

    if (!response.ok) {
      throw new Error(`Search request failed: ${response.status}`);
    }

    const data = await response.json();
    const products = data.resources.results.products || [];

    renderSearchResults(products, query);
  } catch (error) {
    if (error.name === 'AbortError') {
      return;
    }

    console.error('Predictive search error:', error);

    searchResults.innerHTML = `
      <div class="px-3 py-3 text-xs">
        SEARCH UNAVAILABLE
      </div>
    `;

    searchResults.classList.remove('hidden');
  }
}

if (searchToggle) {
  searchToggle.addEventListener('click', function () {
    const isOpen = !searchPanel.classList.contains('hidden');

    if (isOpen) {
      closeSearch();
    } else {
      openSearch();
    }
  });
}

if (searchInput) {
  searchInput.addEventListener('input', function () {
    clearTimeout(searchDebounceTimer);

    const query = searchInput.value.trim();

    if (query.length < 2) {
      searchResults.innerHTML = '';
      searchResults.classList.add('hidden');
      searchStatus.textContent = '';
      return;
    }

    searchDebounceTimer = setTimeout(() => {
      performPredictiveSearch(query);
    }, 250);
  });
}

// Close search when clicking outside it
document.addEventListener('click', function (event) {
  if (
    searchPanel &&
    searchToggle &&
    !searchPanel.classList.contains('hidden') &&
    !searchPanel.contains(event.target) &&
    !searchToggle.contains(event.target)
  ) {
    closeSearch();
  }
});

    // Cart Drawer
    const cartToggles = document.querySelectorAll('.cart-drawer-toggle');
    const cartClose = document.querySelector('.cart-drawer-close');
    const cartDrawer = document.querySelector('.cart-drawer');
    const cartOverlay = document.querySelector('.cart-drawer-overlay');

    function openCart() {
      cartDrawer.classList.remove('translate-x-full');
      cartDrawer.classList.add('translate-x-0');
      cartOverlay.style.display = 'block';
      document.body.style.overflow = 'hidden';

      // Accessibility enhancements
      cartToggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'true');
      });

      // Focus management
      cartDrawer.focus();

      // Trap focus within cart drawer
      trapFocus(cartDrawer);

      // Focus on close button
      if (cartClose) {
        cartClose.focus();
      }

      // Announce cart opening to screen readers
      announceToScreenReader('Shopping cart opened');
    }

    function closeCart() {
      cartDrawer.classList.remove('translate-x-0');
      cartDrawer.classList.add('translate-x-full');
      cartOverlay.style.display = 'none';
      document.body.style.overflow = '';

      // Accessibility enhancements
      cartToggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus(); // Return focus to cart button
      });

      // Announce cart closing to screen readers
      announceToScreenReader('Shopping cart closed');
    }

    cartToggles.forEach((toggle) => {
      toggle.addEventListener('click', openCart);
    });

    if (cartClose) {
      cartClose.addEventListener('click', closeCart);
    }

    if (cartOverlay) {
      cartOverlay.addEventListener('click', closeCart);
    }

    // Close drawers on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        // Check if menu is open (either mobile or desktop position)
        const isDesktop = window.innerWidth >= 768;
        const menuOpen = isDesktop
          ? !mobileMenu.classList.contains('md:-translate-x-full')
          : !mobileMenu.classList.contains('translate-x-full');

        if (menuOpen) {
          closeMenu();
        }
        if (!cartDrawer.classList.contains('translate-x-full')) {
          closeCart();
        }
        if (
          searchPanel &&
          !searchPanel.classList.contains('hidden')
        ) {
          closeSearch();
          searchToggle.focus();
        }
      }
    });

    // Cart quantity controls
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('cart-qty-increase')) {
        const variantId = e.target.getAttribute('data-variant-id');
        updateCartQuantity(variantId, 1);
      } else if (e.target.classList.contains('cart-qty-decrease')) {
        const variantId = e.target.getAttribute('data-variant-id');
        updateCartQuantity(variantId, -1);
      } else if (e.target.classList.contains('cart-item-remove') || e.target.closest('.cart-item-remove')) {
        const button = e.target.closest('.cart-item-remove') || e.target;
        const variantId = button.getAttribute('data-variant-id');
        removeFromCart(variantId);
      }
    });

    function updateCartQuantity(variantId, change) {
      // First get current quantity
      const currentQtySpan = document.querySelector(`[data-variant-id="${variantId}"] .cart-qty`);
      if (!currentQtySpan) return;

      const currentQty = parseInt(currentQtySpan.textContent);
      const newQty = Math.max(0, currentQty + change);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `id=${variantId}&quantity=${newQty}`,
      })
        .then((response) => response.json())
        .then((cart) => {
          updateCartDrawer(cart);
        })
        .catch((error) => {
          console.error('Error updating cart:', error);
        });
    }

    function removeFromCart(variantId) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `id=${variantId}&quantity=0`,
      })
        .then((response) => response.json())
        .then((cart) => {
          updateCartDrawer(cart);
        })
        .catch((error) => {
          console.error('Error removing from cart:', error);
        });
    }

    function updateCartDrawer(cart) {
      // Use the shared update function
      if (window.updateCartDrawerContent) {
        window.updateCartDrawerContent(cart);
      } else {
        console.log('updateCartDrawerContent function not found - keeping drawer open');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"]) return;
  try {
    
  (() => {
    const FIRST_ROW_SIZE = 5;
    const preparedImages = new WeakMap();
    const warmedLookbooks = new Set();

    function getYear(lookbook) {
      const value = [
        lookbook?.season?.slug,
        lookbook?.season?.title,
        lookbook?.slug,
        lookbook?.title,
      ]
        .filter(Boolean)
        .join(' ');

      const matches = String(value).match(/\b(?:19|20)\d{2}\b/g);

      if (!matches || matches.length === 0) {
        return Number.NEGATIVE_INFINITY;
      }

      return Math.max(...matches.map(Number));
    }

    function sortLookbooks(lookbooks) {
      return [...lookbooks].sort((a, b) => {
        const yearA = getYear(a);
        const yearB = getYear(b);

        if (yearA !== yearB) {
          return yearB - yearA;
        }

        return String(a.title || '').localeCompare(
          String(b.title || ''),
          undefined,
          {
            sensitivity: 'base',
          },
        );
      });
    }

    function setStatus(element, message) {
      element.textContent = message;
      element.hidden = false;
    }

    function clearStatus(element) {
      element.textContent = '';
      element.hidden = true;
    }

    function buildLookbookHref(slug) {
      const url = new URL(window.location.href);

      url.searchParams.set('lookbook', slug);
      url.hash = '';

      return `${url.pathname}${url.search}`;
    }

    function renderNavigation(root, lookbooks, selectedSlug) {
      const nav = root.querySelector('[data-lookbook-nav]');
      const list = root.querySelector('[data-lookbook-list]');

      list.replaceChildren();

      const fragment = document.createDocumentFragment();

      lookbooks.forEach((lookbook) => {
        if (
          !lookbook ||
          typeof lookbook.slug !== 'string' ||
          typeof lookbook.title !== 'string'
        ) {
          console.warn(
            'Skipping malformed Lookbook navigation item.',
            lookbook,
          );

          return;
        }

        const item = document.createElement('li');
        const link = document.createElement('a');

        link.href = buildLookbookHref(lookbook.slug);
        link.textContent = lookbook.title;
        link.dataset.lookbookSlug = lookbook.slug;

        if (lookbook.slug === selectedSlug) {
          link.setAttribute('aria-current', 'page');
          item.classList.add('is-selected');
        }

        item.appendChild(link);
        fragment.appendChild(item);
      });

      list.appendChild(fragment);
      nav.hidden = false;
    }

    function updateNavigationSelection(root, selectedSlug) {
      const links = root.querySelectorAll(
        '[data-lookbook-list] a[data-lookbook-slug]',
      );

      links.forEach((link) => {
        const isSelected =
          link.dataset.lookbookSlug === selectedSlug;

        const item = link.closest('li');

        if (item) {
          item.classList.toggle('is-selected', isSelected);
        }

        if (isSelected) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function getImageGeometry(image) {
      const dimensions = image?.asset?.metadata?.dimensions;

      const sourceWidth = Number(dimensions?.width);
      const sourceHeight = Number(dimensions?.height);

      if (
        !Number.isFinite(sourceWidth) ||
        sourceWidth <= 0 ||
        !Number.isFinite(sourceHeight) ||
        sourceHeight <= 0
      ) {
        return null;
      }

      const crop = image.crop || {};

      const left = clamp(Number(crop.left) || 0, 0, 1);
      const right = clamp(Number(crop.right) || 0, 0, 1);
      const top = clamp(Number(crop.top) || 0, 0, 1);
      const bottom = clamp(Number(crop.bottom) || 0, 0, 1);

      if (left + right >= 1 || top + bottom >= 1) {
        console.warn(
          'Ignoring malformed Sanity crop values.',
          image,
        );

        return {
          x: 0,
          y: 0,
          width: Math.round(sourceWidth),
          height: Math.round(sourceHeight),
          hasCrop: false,
          focalX: 0.5,
          focalY: 0.5,
        };
      }

      const x = Math.round(sourceWidth * left);
      const y = Math.round(sourceHeight * top);

      const width = Math.max(
        1,
        Math.round(sourceWidth * (1 - left - right)),
      );

      const height = Math.max(
        1,
        Math.round(sourceHeight * (1 - top - bottom)),
      );

      const hotspotX = Number(image.hotspot?.x);
      const hotspotY = Number(image.hotspot?.y);

      const focalX = Number.isFinite(hotspotX)
        ? clamp(
            (hotspotX * sourceWidth - x) / width,
            0,
            1,
          )
        : 0.5;

      const focalY = Number.isFinite(hotspotY)
        ? clamp(
            (hotspotY * sourceHeight - y) / height,
            0,
            1,
          )
        : 0.5;

      return {
        x,
        y,
        width,
        height,
        hasCrop:
          x !== 0 ||
          y !== 0 ||
          width !== Math.round(sourceWidth) ||
          height !== Math.round(sourceHeight),
        focalX,
        focalY,
      };
    }

    function getMaximumOutputWidth(geometry, aspectRatio) {
      return Math.max(
        1,
        Math.floor(
          Math.min(
            geometry.width,
            geometry.height * aspectRatio,
          ),
        ),
      );
    }

    function buildImageUrl(
      baseUrl,
      geometry,
      width,
      aspectRatio,
    ) {
      const url = new URL(baseUrl);

      if (geometry.hasCrop) {
        url.searchParams.set(
          'rect',
          `${geometry.x},${geometry.y},${geometry.width},${geometry.height}`,
        );
      }

      url.searchParams.set('w', String(width));
      url.searchParams.set(
        'h',
        String(Math.max(1, Math.round(width / aspectRatio))),
      );
      url.searchParams.set('fit', 'crop');
      url.searchParams.set('crop', 'focalpoint');
      url.searchParams.set('fp-x', String(geometry.focalX));
      url.searchParams.set('fp-y', String(geometry.focalY));
      url.searchParams.set('auto', 'format');
      url.searchParams.set('q', '75');

      return url.toString();
    }

    function getResponsiveWidths(geometry, aspectRatio) {
      const maximumWidth = Math.min(
        getMaximumOutputWidth(geometry, aspectRatio),
        1920,
      );

      const candidates = [
        240,
        320,
        400,
        480,
        640,
        800,
        960,
        1200,
        1440,
        1920,
      ].filter((width) => width <= maximumWidth);

      if (!candidates.includes(maximumWidth)) {
        candidates.push(maximumWidth);
      }

      return [...new Set(candidates)].sort(
        (a, b) => a - b,
      );
    }

    function buildSrcset(
      baseUrl,
      geometry,
      widths,
      aspectRatio,
    ) {
      return widths
        .map(
          (width) =>
            `${buildImageUrl(
              baseUrl,
              geometry,
              width,
              aspectRatio,
            )} ${width}w`,
        )
        .join(', ');
    }

    function getFallbackWidth(widths) {
      return (
        widths.find((width) => width >= 960) ||
        widths[widths.length - 1]
      );
    }

    function prepareImage(image, index) {
      if (!image?.asset?.url) {
        console.warn(
          `Skipping Lookbook image ${index + 1}: missing asset URL.`,
          image,
        );

        return null;
      }

      let alt = '';

      if (image.purpose === 'informative') {
        alt =
          typeof image.alt === 'string'
            ? image.alt.trim()
            : '';

        if (!alt) {
          console.warn(
            `Skipping Lookbook image ${index + 1}: informative image has no alt text.`,
            image,
          );

          return null;
        }
      } else if (image.purpose !== 'decorative') {
        console.warn(
          `Skipping Lookbook image ${index + 1}: invalid image purpose.`,
          image,
        );

        return null;
      }

      const geometry = getImageGeometry(image);

      if (!geometry) {
        console.warn(
          `Skipping Lookbook image ${index + 1}: missing or invalid dimensions.`,
          image,
        );

        return null;
      }

      const desktopAspectRatio = 2 / 3;
      const mobileAspectRatio = 3 / 4;

      const desktopWidths = getResponsiveWidths(
        geometry,
        desktopAspectRatio,
      );

      const mobileWidths = getResponsiveWidths(
        geometry,
        mobileAspectRatio,
      );

      const lightboxMaximumWidth = Math.min(
        getMaximumOutputWidth(
          geometry,
          desktopAspectRatio,
        ),
        1920,
      );

      return {
        index,
        alt,
        mobileSrcset: buildSrcset(
          image.asset.url,
          geometry,
          mobileWidths,
          mobileAspectRatio,
        ),
        desktopSrc: buildImageUrl(
          image.asset.url,
          geometry,
          getFallbackWidth(desktopWidths),
          desktopAspectRatio,
        ),
        desktopSrcset: buildSrcset(
          image.asset.url,
          geometry,
          desktopWidths,
          desktopAspectRatio,
        ),
        lightboxSrc: buildImageUrl(
          image.asset.url,
          geometry,
          lightboxMaximumWidth,
          desktopAspectRatio,
        ),
      };
    }

    function getPreparedImages(lookbook) {
      if (!preparedImages.has(lookbook)) {
        const images = Array.isArray(lookbook.images)
          ? lookbook.images
              .map((image, index) => prepareImage(image, index))
              .filter(Boolean)
          : [];

        preparedImages.set(lookbook, images);
      }

      return preparedImages.get(lookbook);
    }

    function appendImagePreload(href, attributes) {
      const link = document.createElement('link');

      link.rel = 'preload';
      link.as = 'image';
      link.href = href;

      Object.entries(attributes).forEach(([name, value]) => {
        link.setAttribute(name, value);
      });

      document.head.appendChild(link);
    }

    function warmLookbook(lookbook) {
      if (!lookbook || warmedLookbooks.has(lookbook.slug)) {
        return;
      }

      warmedLookbooks.add(lookbook.slug);

      getPreparedImages(lookbook)
        .slice(0, FIRST_ROW_SIZE)
        .forEach((image) => {
          appendImagePreload(image.desktopSrc, {
            media: '(max-width: 767px)',
            imagesrcset: image.mobileSrcset,
            imagesizes: 'calc(100vw - 40px)',
          });

          appendImagePreload(image.desktopSrc, {
            media: '(min-width: 768px)',
            imagesrcset: image.desktopSrcset,
            imagesizes: 'calc((100vw - 56px) / 5)',
          });
        });
    }

    function renderGallery(root, lookbook) {
      const detail = root.querySelector(
        '[data-lookbook-detail]',
      );

      const heading = root.querySelector(
        '[data-lookbook-title]',
      );

      const gallery = root.querySelector(
        '[data-lookbook-gallery]',
      );

      const detailStatus = root.querySelector(
        '[data-lookbook-detail-status]',
      );

      gallery.replaceChildren();

      heading.textContent =
        lookbook.title || 'Lookbook';

      heading.hidden = false;
      detail.hidden = false;

      if (
        !Array.isArray(lookbook.images) ||
        lookbook.images.length === 0
      ) {
        setStatus(
          detailStatus,
          'This lookbook does not have any images yet.',
        );

        return;
      }

      const images = getPreparedImages(lookbook);

      if (images.length === 0) {
        setStatus(
          detailStatus,
          'This lookbook does not have any available images.',
        );

        return;
      }

      const fragment =
        document.createDocumentFragment();

      images.forEach((image, renderedIndex) => {
        const wrapper =
          document.createElement('button');

        wrapper.type = 'button';

        wrapper.className =
          'lookbook__image lookbook__image-button';

        wrapper.dataset.lookbookLightbox = 'true';

        wrapper.setAttribute(
          'aria-label',
          `View ${lookbook.title || 'lookbook'} image ${renderedIndex + 1} larger`,
        );

        const picture =
          document.createElement('picture');

        const mobileSource =
          document.createElement('source');

        mobileSource.media = '(max-width: 767px)';
        mobileSource.sizes = 'calc(100vw - 40px)';
        mobileSource.srcset = image.mobileSrcset;

        const img =
          document.createElement('img');

        img.alt = image.alt;

        img.width = 2;
        img.height = 3;

        img.decoding = 'async';

        img.loading =
          renderedIndex < FIRST_ROW_SIZE
            ? 'eager'
            : 'lazy';

        img.fetchPriority =
          renderedIndex < 2
            ? 'high'
            : 'auto';

        img.sizes = 'calc((100vw - 56px) / 5)';
        img.src = image.desktopSrc;
        img.srcset = image.desktopSrcset;

        wrapper.dataset.lightboxSrc = image.lightboxSrc;
        wrapper.dataset.lightboxAlt = image.alt;

        img.addEventListener('error', () => {
          console.warn(
            `Lookbook image ${image.index + 1} failed to load.`,
          );

          wrapper.classList.add('has-error');
        });

        picture.appendChild(mobileSource);
        picture.appendChild(img);
        wrapper.appendChild(picture);
        fragment.appendChild(wrapper);
      });

      gallery.appendChild(fragment);

      clearStatus(detailStatus);
    }

    function loadLookbook(
      root,
      lookbook,
      {
        updateUrl = true,
        replaceUrl = false,
      } = {},
    ) {
      renderGallery(root, lookbook);

      updateNavigationSelection(
        root,
        lookbook.slug,
      );

      if (updateUrl) {
        const href = buildLookbookHref(lookbook.slug);

        if (replaceUrl) {
          window.history.replaceState(
            { lookbook: lookbook.slug },
            '',
            href,
          );
        } else {
          window.history.pushState(
            { lookbook: lookbook.slug },
            '',
            href,
          );
        }
      }
    }

    function initLookbookLightbox(root) {
      const modal = root.querySelector(
        '[data-lookbook-lightbox-modal]',
      );

      const modalImage = root.querySelector(
        '[data-lookbook-lightbox-image]',
      );

      const counter = root.querySelector(
        '[data-lookbook-lightbox-counter]',
      );

      const prevButton = root.querySelector(
        '[data-lookbook-lightbox-prev]',
      );

      const nextButton = root.querySelector(
        '[data-lookbook-lightbox-next]',
      );

      const closeButtons = root.querySelectorAll(
        '[data-lookbook-lightbox-close]',
      );

      if (!modal || !modalImage) {
        return;
      }

      let currentIndex = 0;
      let previouslyFocusedElement = null;

      function getItems() {
        return Array.from(
          root.querySelectorAll(
            '[data-lookbook-lightbox]',
          ),
        );
      }

      function showImage(index) {
        const items = getItems();

        if (items.length === 0) {
          return;
        }

        if (index < 0) {
          index = items.length - 1;
        }

        if (index >= items.length) {
          index = 0;
        }

        currentIndex = index;

        const item = items[currentIndex];

        modalImage.src =
          item.dataset.lightboxSrc || '';

        modalImage.alt =
          item.dataset.lightboxAlt || '';

        if (counter) {
          counter.textContent =
            `${currentIndex + 1} / ${items.length}`;
        }
      }

      function openLightbox(index) {
        previouslyFocusedElement =
          document.activeElement;

        showImage(index);

        modal.hidden = false;
        modal.setAttribute(
          'aria-hidden',
          'false',
        );

        document.body.classList.add(
          'lookbook-lightbox-open',
        );

        modal
          .querySelector(
            '[data-lookbook-lightbox-close]',
          )
          ?.focus();
      }

      function closeLightbox() {
        modal.hidden = true;

        modal.setAttribute(
          'aria-hidden',
          'true',
        );

        document.body.classList.remove(
          'lookbook-lightbox-open',
        );

        modalImage.src = '';

        previouslyFocusedElement?.focus();
      }

      root.addEventListener('click', (event) => {
        const item = event.target.closest(
          '[data-lookbook-lightbox]',
        );

        if (!item || !root.contains(item)) {
          return;
        }

        const items = getItems();

        const index =
          items.indexOf(item);

        if (index !== -1) {
          openLightbox(index);
        }
      });

      prevButton?.addEventListener(
        'click',
        () => {
          showImage(currentIndex - 1);
        },
      );

      nextButton?.addEventListener(
        'click',
        () => {
          showImage(currentIndex + 1);
        },
      );

      closeButtons.forEach((button) => {
        button.addEventListener(
          'click',
          closeLightbox,
        );
      });

      document.addEventListener(
        'keydown',
        (event) => {
          if (modal.hidden) {
            return;
          }

          if (event.key === 'Escape') {
            closeLightbox();
          }

          if (event.key === 'ArrowLeft') {
            showImage(currentIndex - 1);
          }

          if (event.key === 'ArrowRight') {
            showImage(currentIndex + 1);
          }
        },
      );
    }

    async function initLookbookSection(root) {
      if (
        root.dataset.lookbookInitialized === 'true'
      ) {
        return;
      }

      root.dataset.lookbookInitialized = 'true';
      initLookbookLightbox(root);

      const status = root.querySelector(
        '[data-lookbook-status]',
      );

      const detail = root.querySelector(
        '[data-lookbook-detail]',
      );

      const detailStatus = root.querySelector(
        '[data-lookbook-detail-status]',
      );

      const nav = root.querySelector(
        '[data-lookbook-nav]',
      );

      detail.hidden = true;

      clearStatus(detailStatus);

      setStatus(
        status,
        'Loading lookbooks…',
      );

      let lookbooks;

      try {
        if (!root.lookbooksRequest) {
          throw new Error(
            'Sanity storefront configuration is incomplete.',
          );
        }

        const result = await root.lookbooksRequest;

        if (!Array.isArray(result)) {
          throw new Error(
            'Lookbook query did not return an array.',
          );
        }

        lookbooks = sortLookbooks(result);
      } catch (error) {
        console.error(
          'Unable to load Lookbook navigation.',
          error,
        );

        setStatus(
          status,
          'Lookbooks are temporarily unavailable.',
        );

        return;
      }

      if (lookbooks.length === 0) {
        setStatus(
          status,
          'No lookbooks are available.',
        );

        return;
      }

      const requestedSlug = new URL(
        window.location.href,
      ).searchParams.get('lookbook');

      const requestedLookbook = lookbooks.find(
        (lookbook) =>
          lookbook.slug === requestedSlug,
      );

      const selectedLookbook =
        requestedLookbook ||
        lookbooks[0];

      renderNavigation(
        root,
        lookbooks,
        selectedLookbook.slug,
      );

      root.classList.add('is-loaded');

      clearStatus(status);

      function findLinkedLookbook(event) {
        const link = event.target.closest?.(
          'a[data-lookbook-slug]',
        );

        if (!link || !nav.contains(link)) {
          return {};
        }

        return {
          link,
          lookbook: lookbooks.find(
            (item) =>
              item.slug === link.dataset.lookbookSlug,
          ),
        };
      }

      ['pointerover', 'focusin', 'touchstart'].forEach((type) => {
        nav.addEventListener(
          type,
          (event) => {
            warmLookbook(findLinkedLookbook(event).lookbook);
          },
          {
            passive: true,
          },
        );
      });

      nav.addEventListener('click', (event) => {
        const { link, lookbook } = findLinkedLookbook(event);

        if (!link) {
          return;
        }

        event.preventDefault();

        if (
          !lookbook ||
          link.getAttribute('aria-current') === 'page'
        ) {
          return;
        }

        loadLookbook(
          root,
          lookbook,
          {
            updateUrl: true,
          },
        );
      });

      loadLookbook(
        root,
        selectedLookbook,
        {
          updateUrl: !requestedLookbook,
          replaceUrl: !requestedLookbook,
        },
      );

      window.addEventListener('popstate', () => {
        const slug = new URL(
          window.location.href,
        ).searchParams.get('lookbook');

        const lookbook = lookbooks.find(
          (item) => item.slug === slug,
        );

        loadLookbook(
          root,
          lookbook || lookbooks[0],
          {
            updateUrl: false,
          },
        );
      });
    }

    function initAllLookbookSections() {
      document
        .querySelectorAll(
          '[data-lookbook-section]',
        )
        .forEach((root) => {
          initLookbookSection(root).catch(
            (error) => {
              console.error(
                'Lookbook initialization failed.',
                error,
              );

              const status =
                root.querySelector(
                  '[data-lookbook-status]',
                );

              if (status) {
                setStatus(
                  status,
                  'Lookbooks are temporarily unavailable.',
                );
              }
            },
          );
        });
    }

    if (
      document.readyState === 'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        initAllLookbookSections,
        {
          once: true,
        },
      );
    } else {
      initAllLookbookSections();
    }
    const scrollTopButton = document.querySelector(
  '.lookbook-scroll-top'
);

if (scrollTopButton) {
  window.addEventListener('scroll', () => {
    if (window.scrollY > 800) {
      scrollTopButton.classList.add('is-visible');
    } else {
      scrollTopButton.classList.remove('is-visible');
    }
  });

  scrollTopButton.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    function normalizeIndex(index, slideCount) {
      return ((index % slideCount) + slideCount) % slideCount;
    }

    async function decodeImage(image) {
      if (!image) return false;

      try {
        await image.decode();
      } catch (_error) {
        // A decoded, renderable image can still reject decode() in some browsers.
      }

      return image.complete && image.naturalWidth > 0;
    }

    function prepareImage(image, priority = 'auto') {
      if (!image) return Promise.resolve(false);

      if (
        priority === 'high' ||
        image.fetchPriority !== 'high'
      ) {
        image.fetchPriority = priority;
      }

      if (image.complete) {
        return decodeImage(image);
      }

      return new Promise((resolve) => {
        let settled = false;

        const finish = async (didLoad) => {
          if (settled) return;

          settled = true;
          image.removeEventListener('load', handleLoad);
          image.removeEventListener('error', handleError);

          resolve(didLoad ? await decodeImage(image) : false);
        };

        const handleLoad = () => {
          finish(true);
        };

        const handleError = () => {
          finish(false);
        };

        image.addEventListener('load', handleLoad, { once: true });
        image.addEventListener('error', handleError, { once: true });

        image.loading = 'eager';

        if (image.complete) {
          finish(image.naturalWidth > 0);
        }
      });
    }

    function initProductGallery(gallery) {
      const viewport = gallery.querySelector(
        '[data-product-gallery-viewport]',
      );
      const slides = [
        ...gallery.querySelectorAll('.product-gallery__slide'),
      ];
      const previousButton = gallery.querySelector(
        '.product-gallery__arrow--prev',
      );
      const nextButton = gallery.querySelector(
        '.product-gallery__arrow--next',
      );
      const currentCounter = gallery.querySelector(
        '[data-product-gallery-current]',
      );

      if (!viewport || slides.length < 2) return;

      let currentIndex = Math.max(
        0,
        slides.findIndex((slide) =>
          slide.classList.contains('is-active'),
        ),
      );
      let requestedIndex = currentIndex;
      let transitionToken = 0;

      const getImage = (index) =>
        slides[index]?.querySelector('.product-gallery__image');

      const warmAdjacentImages = (index) => {
        const previousIndex = normalizeIndex(
          index - 1,
          slides.length,
        );
        const nextIndex = normalizeIndex(
          index + 1,
          slides.length,
        );

        new Set([previousIndex, nextIndex]).forEach(
          (adjacentIndex) => {
            prepareImage(getImage(adjacentIndex), 'low');
          },
        );
      };

      const scheduleWarmAdjacentImages = (index) => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(
            () => warmAdjacentImages(index),
            { timeout: 1200 },
          );
          return;
        }

        window.setTimeout(
          () => warmAdjacentImages(index),
          250,
        );
      };

      const showGallerySlide = async (index) => {
        const targetIndex = normalizeIndex(index, slides.length);
        const token = ++transitionToken;

        requestedIndex = targetIndex;

        if (targetIndex === currentIndex) {
          viewport.setAttribute('aria-busy', 'false');
          scheduleWarmAdjacentImages(currentIndex);
          return;
        }

        viewport.setAttribute('aria-busy', 'true');

        const isReady = await prepareImage(
          getImage(targetIndex),
          'high',
        );

        if (token !== transitionToken) return;

        if (!isReady) {
          console.warn(
            `Unable to display product image ${targetIndex + 1}.`,
          );
          requestedIndex = currentIndex;
          viewport.setAttribute('aria-busy', 'false');
          return;
        }

        slides[currentIndex].classList.remove('is-active');
        slides[currentIndex].setAttribute('aria-hidden', 'true');
        slides[targetIndex].classList.add('is-active');
        slides[targetIndex].setAttribute('aria-hidden', 'false');

        currentIndex = targetIndex;

        if (currentCounter) {
          currentCounter.textContent = String(currentIndex + 1);
        }

        viewport.setAttribute('aria-busy', 'false');
        scheduleWarmAdjacentImages(currentIndex);
      };

      previousButton?.addEventListener('click', () => {
        showGallerySlide(requestedIndex - 1);
      });

      nextButton?.addEventListener('click', () => {
        showGallerySlide(requestedIndex + 1);
      });

      gallery
        .querySelectorAll('[data-product-gallery-step]')
        .forEach((hitArea) => {
          hitArea.addEventListener('click', () => {
            showGallerySlide(
              requestedIndex + Number(hitArea.dataset.productGalleryStep),
            );
          });
        });

      /* MOBILE SWIPE NAVIGATION */

      let touchStartX = 0;
      let touchStartY = 0;

      viewport.addEventListener(
        'touchstart',
        (event) => {
          if (window.innerWidth >= 768) return;

          const touch = event.changedTouches[0];

          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
        },
        { passive: true },
      );

      viewport.addEventListener(
        'touchend',
        (event) => {
          if (window.innerWidth >= 768) return;

          const touch = event.changedTouches[0];

          const deltaX = touch.clientX - touchStartX;
          const deltaY = touch.clientY - touchStartY;

          const minimumSwipeDistance = 40;

          // Ignore taps, tiny movements, and mostly vertical swipes
          if (
            Math.abs(deltaX) < minimumSwipeDistance ||
            Math.abs(deltaX) <= Math.abs(deltaY)
          ) {
            return;
          }

          if (deltaX < 0) {
            // Swipe left → next image
            showGallerySlide(requestedIndex + 1);
          } else {
            // Swipe right → previous image
            showGallerySlide(requestedIndex - 1);
          }
        },
        { passive: true },
      );

      scheduleWarmAdjacentImages(currentIndex);
    }

    document
      .querySelectorAll('[data-product-gallery]')
      .forEach(initProductGallery);
  })();

  } catch(e) { console.error(e); }
})();
})();
